import * as G from "./global-state"
import {React_root} from "./global-state-react"
import ReactDOM from "react-dom/client"

const main = () => {
    G.init_global_state()
    const elt = document.getElementById("root")
    if (elt === null) console.error("no root 7a39343c510232c5")
    else ReactDOM.createRoot(elt).render(<React_root/>)
}

main()
